import { Component, inject, input } from '@angular/core';
import { ProvenueErrorService } from '@core/services/provenue-error.service';
import { environment } from '@environments/environment';
import { DvmService } from '@features/digital-venue/services/dvm.service';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';

@Component({
  standalone: false,
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.css'],
})
export class ModalsComponent {
  provenueErrorService = inject(ProvenueErrorService);

  readonly title = input<string>('');
  readonly content = input<string>('');
  readonly closeBtnName = input<string | undefined>(undefined);
  readonly acceptBtnName = input<string | undefined>(undefined);
  readonly closeFunction = input<(() => void) | undefined>(undefined);
  readonly acceptFunction = input<(() => void) | undefined>(undefined);

  // Legend
  availableColor: string = 'main-light';
  mySeatsColor: string = 'red';
  selectedColor: string = 'purple';
  isolatedColor: string = 'orange';

  private dialogRef = inject(BrnDialogRef);
  private dvmService = inject(DvmService);

  get isTopview() {
    return this.dvmService.isTopview;
  }

  accept() {
    this.dialogRef.close();
    const fn = this.acceptFunction();
    if (fn) {
      fn();
    }
  }

  close() {
    this.dialogRef.close();
    const fn = this.closeFunction();
    if (fn) {
      fn();
    }
  }

  get showProvenueErrorInfo() {
    const hasPvErrorId =
      this.provenueErrorService.getPvRequestId() ||
      this.provenueErrorService.getPvProxyRequestId();
    return environment.showProvenueErrorInfo && hasPvErrorId;
  }
}
